/* Product image popup (PhotoSwipe): dot indicator (phones, tablets and desktop).
   PhotoSwipe hides its arrows on touch screens, so shoppers could not tell there were more photos;
   on desktop the dots add a quick "you are on photo 2 of 5" cue next to the arrows.

   Never more than 5 dots (products can have 30+ photos). Same "sliding window" pattern as Instagram
   and Material Design: the blue dot starts on the left with the first photo, moves right as you go,
   then stays in the middle while the row of dots slides, and moves right again over the last two
   photos. A dot at the edge of the row is drawn smaller when more photos continue beyond it.
   The current index is read from the product Flickity carousel, which theme.js keeps in sync with
   the popup. */
(function () {
  var MAX = 5;
  var pswp = document.querySelector('.pswp');
  var ui = pswp && pswp.querySelector('.pswp__ui');
  if (!pswp || !ui) return;

  var style = document.createElement('style');
  style.textContent =
    '.bf-pswp-dots{position:fixed;left:50%;transform:translateX(-50%);z-index:1560;display:none;align-items:center;gap:9px;' +
    'padding:4px 0;background:none;border:0;box-shadow:none;pointer-events:none;max-width:90vw;box-sizing:border-box}' +
    '.bf-pswp-dots[data-on]{display:flex}' +
    '.bf-pswp-dots i{display:block;width:8px;height:8px;border-radius:50%;background:#bcc0cf;transition:background .2s,transform .2s;flex:0 0 auto}' +
    '.bf-pswp-dots i.is-small{transform:scale(.6)}' +
    '.bf-pswp-dots i.is-active{background:#364684;transform:scale(1.35)}' +
    /* desktop: the photo runs to the bottom edge, so the dots sit on it; a soft white glow keeps them readable */
    '@media (min-width:981px){.bf-pswp-dots{gap:11px}.bf-pswp-dots i{width:9px;height:9px;filter:drop-shadow(0 0 3px rgba(255,255,255,.95))}}' +
    '.pswp--zoomed-in .bf-pswp-dots{opacity:0}';
  document.head.appendChild(style);

  var wrap = document.createElement('div');
  wrap.className = 'bf-pswp-dots';
  wrap.setAttribute('aria-hidden', 'true');
  ui.appendChild(wrap);

  var shown = 0, raf = 0, lastKey = '', lastBottom = null;

  function carousel() {
    var el = document.querySelector('.js-carousel-main');
    return el && window.Flickity ? window.Flickity.data(el) : null;
  }

  function build(k) {
    wrap.innerHTML = '';
    for (var i = 0; i < k; i++) wrap.appendChild(document.createElement('i'));
    shown = k;
    lastKey = '';
  }

  function currentIndex(f) {
    if (f && typeof f.selectedIndex === 'number') return f.selectedIndex;
    return 0;
  }

  /* Which photo each of the (up to 5) dots stands for, and how they are drawn. */
  function paint(n, idx) {
    var k = Math.min(n, MAX);
    if (k !== shown) build(k);
    var start = Math.max(0, Math.min(idx - Math.floor(MAX / 2), n - k));
    var key = n + ':' + idx + ':' + start;
    if (key === lastKey) return;
    lastKey = key;
    for (var s = 0; s < k; s++) {
      var el = wrap.children[s];
      var photo = start + s;
      var small = (s === 0 && start > 0) || (s === k - 1 && start + k < n);
      el.classList.toggle('is-active', photo === idx);
      el.classList.toggle('is-small', small && photo !== idx);
    }
  }

  /* Bottom edge of the photo on screen. While you swipe, the centre of the screen can briefly sit
     in the gap between two photos; in that moment keep the last known position instead of
     dropping the dots to the bottom of the screen. */
  function imageBottom() {
    var imgs = pswp.querySelectorAll('img.pswp__img');
    var cx = window.innerWidth / 2, bottom = null, nearest = null, nearestDist = Infinity;
    for (var i = 0; i < imgs.length; i++) {
      var r = imgs[i].getBoundingClientRect();
      if (r.width <= 0 || r.height <= 0) continue;
      if (r.left <= cx && r.right >= cx) bottom = r.bottom;
      var d = Math.abs((r.left + r.right) / 2 - cx);
      if (d < nearestDist) { nearestDist = d; nearest = r.bottom; }
    }
    if (bottom === null) bottom = nearest;
    if (bottom !== null) lastBottom = bottom;
    return lastBottom;
  }

  function tick() {
    raf = 0;
    if (!pswp.classList.contains('pswp--open')) { wrap.removeAttribute('data-on'); lastBottom = null; return; }
    var f = carousel();
    var n = f && f.slides ? f.slides.length : 0;
    if (n < 2) {
      wrap.removeAttribute('data-on');
    } else {
      wrap.setAttribute('data-on', '');
      paint(n, Math.max(0, Math.min(n - 1, currentIndex(f))));
      var b = imageBottom();
      var h = wrap.offsetHeight || 24;
      var top = b === null ? window.innerHeight - h - 24 : b + 12;
      /* keep it on screen: if the image runs to the bottom edge, sit just above the edge */
      top = Math.min(top, window.innerHeight - h - 14);
      wrap.style.top = Math.round(top) + 'px';
    }
    raf = requestAnimationFrame(tick);
  }

  new MutationObserver(function () {
    if (pswp.classList.contains('pswp--open') && !raf) raf = requestAnimationFrame(tick);
  }).observe(pswp, { attributes: true, attributeFilter: ['class'] });
})();

/* Product page: clicking/tapping the main photo opens the same popup as the magnifier button.
   Each photo slide has its own magnifier button (theme.js opens the popup at that photo), so a
   click on the photo simply triggers that slide's button. Drags/swipes (pointer moved more than
   10px between press and release) are ignored so swiping between photos still works.
   Works with mouse, trackpad and touch: the press position is recorded from pointer, mouse and
   touch events and cleared after every click, so a missing press event can never block a click. */
(function () {
  var style = document.createElement('style');
  style.textContent = '.js-carousel-main:not(.is-pointer-down) img.product__image{cursor:zoom-in}';
  document.head.appendChild(style);

  var down = null, lastOpen = 0;

  function rec(e) {
    var p = (e.touches && e.touches[0]) || e;
    if (typeof p.clientX === 'number') down = { x: p.clientX, y: p.clientY };
  }
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (t) {
    document.addEventListener(t, rec, { capture: true, passive: true });
  });

  function openFrom(img) {
    var pswp = document.querySelector('.pswp');
    if (pswp && pswp.classList.contains('pswp--open')) return;
    if (Date.now() - lastOpen < 700) return;
    var wrapper = img.closest('[data-product-single-media-wrapper]');
    var btn = (wrapper && wrapper.querySelector('.zoom_btn')) ||
      (img.closest('.image-slide') && img.closest('.image-slide').querySelector('.zoom_btn'));
    if (!btn) return;
    lastOpen = Date.now();
    btn.click();
  }

  document.addEventListener('click', function (e) {
    var d = down;
    down = null;
    var t = e.target;
    if (!t || !t.closest) return;
    var img = t.closest('.js-carousel-main img.product__image');
    if (!img) return;
    if (t.closest('.zoom_btn, button, .bf-media-actions, .wishlist_button')) return;
    if (d && (Math.abs(e.clientX - d.x) > 10 || Math.abs(e.clientY - d.y) > 10)) return;
    openFrom(img);
  }, true);
})();
